import { Pharmacy } from '../interfaces/pharmacy.interface';
import { Action } from 'redux';

export const PHARMACY_REDUX_STATE_ID = 'pharmacys';
export const RETAIL_PHARMACY_TYPE_ID = 1;
export const MAIL_PHARMACY_TYPE_ID = 2;


export interface PharmacyState {
  pharmacys: Pharmacy[];
  selectedPharmacy: Pharmacy;
}

export class PharmacyAction implements Action {
  type: string;
  pharmacy?: Pharmacy;
  pharmacys?: Pharmacy[];
  selectedPharmacy?: Pharmacy;
}

const INITIAL_STATE: PharmacyState = {
  pharmacys: [],
  selectedPharmacy: null
};

export const ADD_PHARMACY = 'ADD_PHARMACY';
export const REMOVE_PHARMACY = 'REMOVE_PHARMACY';
export const SELECT_PHARMACY = 'SELECT_PHARMACY';
export const SET_PHARMACY_STATE = 'SET_PHARMACY_STATE';

export const RESET_DOC = 'RESET_DOC';

export function addPharmacy(pharmacy: Pharmacy): PharmacyAction {
  return { type: ADD_PHARMACY, pharmacy };
}
export function removePharmacys(pharmacy: Pharmacy): PharmacyAction {
  return { type: REMOVE_PHARMACY, pharmacy };
}
export function selectPharmacy(pharmacy: Pharmacy): PharmacyAction {
  return { type: SELECT_PHARMACY, pharmacy };
}
export function setPharmacyState(pharmacys: Pharmacy[], selectedPharmacy: Pharmacy) {
  return { type: SET_PHARMACY_STATE, pharmacys, selectedPharmacy };
}

export function Pharmacys( state: PharmacyState = INITIAL_STATE, action: PharmacyAction ) {

  const copiedState: PharmacyState = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SELECT_PHARMACY:
      copiedState.selectedPharmacy = action.pharmacy;
      return Object.assign({}, state, copiedState);

    case ADD_PHARMACY:
      copiedState.pharmacys.push(action.pharmacy);
      return Object.assign({}, state, copiedState);

    case REMOVE_PHARMACY:
      copiedState.pharmacys
        = copiedState.pharmacys.filter( curState => {
          return curState.pharmacyId !== action.pharmacy.pharmacyId;
        } );
      return Object.assign({}, state, copiedState);

    case SET_PHARMACY_STATE:
      copiedState.pharmacys = action.pharmacys;
      copiedState.selectedPharmacy = action.selectedPharmacy;
      return Object.assign({}, state, copiedState);

    default:
      return state;
  }
}
